import { CompanyLink, Counter, TextLine, ItemsList, Money } from 'components/common/tableComponents/cellTemplates';
import Classifiers from 'components/common/tableComponents/cellTemplates/Classifiers';
import ProjectMassSidebarLink from './ProjectMassSidebarLink';
import WorksheetMassLink from './WorksheetMassLink';

const ProjectMassTableTemplates = {
    classifiers:          Classifiers,
    number:               Counter,
    approval:             ItemsList,
    candidates:           ItemsList,
    company:              CompanyLink,
    participants:         ItemsList,
    workcommit:           ItemsList,
    responsible:          ItemsList,
    result:               ItemsList,
    negwithclient:        ItemsList,
    participantsDetailed: ItemsList,
    positionResult:       ItemsList,
    details:              ProjectMassSidebarLink,
    posname:              WorksheetMassLink,
    salary:               Money,
    feeperpos:            Money,
    amountmin:            Money,
    amountmax:            Money,
};

export default function getProjectMassTableTemplate(columnName) {
    return ProjectMassTableTemplates[columnName] || TextLine;
}
